import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FC } from 'react';

interface BookingErrorReasonsProps {
  reasons: string[];
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    reasonList: {
      margin: theme.spacing(1, 0, 0),
      paddingLeft: theme.spacing(2.5),
    },
    reason: {
      fontSize: '16px',
    },
  }),
);

/**
 * ANS-12793: every reason a booking was rejected, worded the way the service worded them.
 * The first message is the summary the service leads with; the ones after it name a file each.
 * Nothing is reworded or filtered here - the text is owned downstream so the dialog and the
 * service log quote the same wording.
 */
export const BookingErrorReasons: FC<BookingErrorReasonsProps> = ({ reasons }) => {
  const classes = useStyles();
  const [summary, ...fileReasons] = reasons;

  return (
    <div data-testid="BookOrderErrorReasons">
      <Typography variant="body1">{summary}</Typography>
      {fileReasons.length > 0 && (
        <ul className={classes.reasonList}>
          {fileReasons.map((reason, index) => (
            <li key={`${index}-${reason}`} className={classes.reason} data-testid="BookOrderErrorReason">
              {reason}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
